module.exports = __webpack_public_path__ + "static/img/main-preview-doc.c7bbfbcc.svg";